import React from 'react'

// Types ----

type CodeProps = { code: string }

// Component ----

function Code({code}: CodeProps) {
  return <p key={code} className='text-md font-medium text-gray-900 font-mono tracking-wider'>
    {code}
  </p>
}

export {Code};